import gsap, { SplitText } from '@lib/gsap'
import { onMount, onDestroy, onPageIn } from "./_";
import { Scroll } from '@/lib/scroll';

export default function (element, dataset) {
  const splitTextInstances = [];
  const eventListeners = [];
  let windowLoadHandler = null;
  let timer;

  function removeHash() {
    history.replaceState(null, document.title, `${window.location.origin}${window.location.pathname}${window.location.search}`);
  }

  function setupTOC() {
    // window.FinsweetAttributes.push(['toc', (api) => {
    //   const menuBtns = document.querySelectorAll('.article_toc_link, .article_toc_inner-link');
    //   menuBtns.forEach((menuBtn) => {
    //     const clickHandler = () => setTimeout(removeHash);
    //     menuBtn.addEventListener('click', clickHandler);
    //     eventListeners.push({ element: menuBtn, event: 'click', handler: clickHandler });
    //   });
    // }]);
  }

  onMount(() => {
    element.querySelectorAll('.article_content h2').forEach((h2) => {
      if (h2._split) h2._split.revert();
      const split = new SplitText(h2, { type: 'lines' });
      splitTextInstances.push(split);
      gsap.set(split.lines[0], { x: 16 });
    });



    gsap.set('.article_content', {
      y: 5,
      opacity: 0
    })

    gsap.set('.article_heading, .article_card_wrap', {
      filter: 'blur(20px)',
      opacity: 0
    })

    gsap.set('.article_left_wrap .g_tag_wrap', {
      opacity: 0,
      y: -20
    })

    gsap.set('.article_tags_wrap .g_tag_wrap', {
      yPercent: gsap.utils.wrap([-50, 50, -50]),
      xPercent: gsap.utils.wrap([-50, 0, 50]),
      opacity: 0
    })


    timer = setInterval(() => Scroll.resize(), 3000);

    document.querySelectorAll('.article_line').forEach((line) => {
      const blockCount = Math.floor(line.offsetWidth / 15);
      line.innerHTML = '';
      for (let i = 0; i < blockCount; i++) {
        const block = document.createElement('div');
        block.className = 'writing_block';
        Object.assign(block.style, {
          width: '15px',
          height: '0px',
          display: 'inline-block',
          verticalAlign: 'bottom'
        });
        line.appendChild(block);
      }
    });

    document.querySelectorAll('.article_header_wrap').forEach((headerWrap) => {
      const blocks = Array.from(headerWrap.querySelectorAll('.writing_block'));
      const distributeConfig = { base: -20, amount: -36, ease: 'power4.in' };

      const mousemoveHandler = (e) => {
        const xPercent = (e.clientX - headerWrap.getBoundingClientRect().left) / headerWrap.offsetWidth;
        gsap.to(blocks, {
          height: gsap.utils.distribute({ ...distributeConfig, from: xPercent }),
          opacity: gsap.utils.distribute({ ...distributeConfig, from: xPercent }),
          duration: 0.2,
          ease: 'none',
        });
      };

      const mouseleaveHandler = () => {
        gsap.to(blocks, { height: '0rem', duration: 0.3, ease: 'power2.inOut' });
      };

      headerWrap.addEventListener('mousemove', mousemoveHandler);
      headerWrap.addEventListener('mouseleave', mouseleaveHandler);
      eventListeners.push(
        { element: headerWrap, event: 'mousemove', handler: mousemoveHandler },
        { element: headerWrap, event: 'mouseleave', handler: mouseleaveHandler }
      );
    });

    setupTOC();
    windowLoadHandler = () => Scroll.resize();
    window.addEventListener("load", windowLoadHandler);

    if (window.FinsweetAttributes) {
      if (window.FinsweetAttributes.modules.toc.restart) {
        window.FinsweetAttributes.modules.toc.restart()
      }
    }
  });

  onPageIn(async () => {

    let tl = gsap.timeline({ paused: true })

    tl.to('.article_content', {
      y: 0,
      opacity: 1,
      delay: 0.25
    })

    tl.to('.article_heading', {
      filter: 'blur(0px)',
      opacity: 1
    }, '0')
    tl.to('.article_tags_wrap .g_tag_wrap', {
      yPercent: 0,
      xPercent: 0,
      opacity: 1
    }, '0')
    tl.to('.article_card_wrap', {
      filter: 'blur(0px)',
      opacity: 1
    }, '0+=0.125')

    tl.to('.article_left_wrap .g_tag_wrap', {
      opacity: 1,
      y: 0
    }, '<+=0.125')



    await tl.play()
  })

  onDestroy(() => {
    splitTextInstances.forEach((split) => {
      try { split.revert(); } catch (e) { console.warn('Error reverting SplitText:', e); }
    });
    splitTextInstances.length = 0;

    eventListeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    eventListeners.length = 0;

    if (windowLoadHandler) {
      window.removeEventListener("load", windowLoadHandler);
      windowLoadHandler = null;
    }

    clearInterval(timer);
    timer = null;
  });
}
